import React, { useState, useEffect, useRef, useContext } from 'react'
import { Button, Card, Modal } from 'react-daisyui'
import ProfilUnknow from '../../assets/profile-unknown.png'
import { session, clearSession } from '../../utils/AuthSession'
import { API } from '../../utils/api'
import { Api } from '../../utils/apiServer'
import { useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import { AiOutlineEdit, AiOutlineDelete, AiOutlineUser, AiOutlineMail, AiOutlinePhone, AiOutlineEnvironment, AiOutlinePlus, AiOutlineLogout } from "react-icons/ai"
import { FaMapMarkerAlt } from "react-icons/fa"
import { useForm } from "react-hook-form"
import Select from 'react-select'
import Swal from 'sweetalert2'
import { ThemeContext } from '../../context/ThemeContext'

function Profile() {

    const [profile, setProfile] = useState(null)
    const [profileImage, setProfileImage] = useState(null)
    const [address, setAddress] = useState([])
    const [province, setProvince] = useState([])
    const [city, setCity] = useState([])
    const [dialogTitle, setDialogTitle] = useState()
    const [citySelected, setCitySelected] = useState()
    const [provinceSelected, setProvinceSelected] = useState()
    const [typeSubmit, setTypeSubmit] = useState('create')
    const [proccessing, setProccessing] = useState(true)

    const navigate = useNavigate()
    const selectInputRef = useRef()

    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm()

    const onSubmit = async (data) => {
        console.log(data)
        setProccessing(false)
        switch (typeSubmit) {
            case "create":
                const params = {
                    access: 'auth',
                    method: API.ADDRESS_CREATE.type,
                    url: API.ADDRESS_CREATE.url,
                    reqBody: {
                        address_name: data.address_name,
                        province_id: data.province_id,
                        province_name: data.province_name,
                        city_id: data.city_id,
                        city_type: data.city_type,
                        city_name: data.city_name,
                        full_address: data.address,
                        postal_code: data.postal_code
                    }
                }
                try {
                    const response = await Api(params)
                    if (response.status) {
                        toast(response.message);
                        document.getElementById('address_modal').close()
                        initAddress()
                        setProccessing(true)
                    } else {
                        toast.error(response.message)
                    }
                } catch (error) {
                    toast.error(error.message)
                }


                break;

            case "edit": 
            const params2 = {
                access: 'auth',
                method: API.ADDRESS_EDIT.type,
                url: API.ADDRESS_EDIT.url,
                reqBody: {
                    address_id: data.address_id,
                    address_name: data.address_name,
                    province_id: data.province_id,
                    province_name: data.province_name,
                    city_id: data.city_id,
                    city_type: data.city_type,
                    city_name: data.city_name,
                    full_address: data.address,
                    postal_code: data.postal_code
                }
            }
            try {
                const response = await Api(params2)
                if (response.status) {
                    toast(response.message);
                    document.getElementById('address_modal').close()
                    initAddress()
                    setProccessing(true)
                } else {
                    toast.error(response.message)
                }
            } catch (error) {
                toast.error(error.message)
            }
                break;
            default:
                break;
        }
    }



    useEffect(() => {
        init();
        initAddress()
        initProvince()
    }, [])
    const init = async () => {
        const params = {
            access: 'auth',
            method: API.PROFILE.type,
            url: API.PROFILE.url,
            reqBody: {}
        }
        const response = await Api(params);
        if (response) {
            setProfile(response.data)
            setProfileImage(response.data.image_profile)
        }
    }

    const initProvince = async () => {
        const params = {
            access: 'auth',
            method: API.PROVINCE.type,
            url: API.PROVINCE.url,
            reqBody: {}
        }
        try {
            const response = await Api(params);
            if (response.status) {
                setProvince(response.data.map((p) => {
                    return {
                        value: p.province_id,
                        label: p.province
                    }
                }))
            } else {
                toast.error(response.message)
            }
        } catch (error) {

        }
    }

    // console.log('province', province)

    const initAddress = async () => {
        const params = {
            access: 'auth',
            method: API.ADDRESS.type,
            url: API.ADDRESS.url,
            reqBody: {}
        }
        try {
            const response = await Api(params);
            if (response.status) {
                setAddress(response.data)
            } else {
                toast.error(response.message)
            }
        } catch (error) {
            toast.error(error.message)
        }

    }

    const handleLogout = async () => {
        await clearSession()
        navigate('/auth/login')
    }



    const handleAddAddress = async (title, type) => {
        if (address.length < process.env.REACT_APP_MAX_ADDRESS) {
            setDialogTitle(title)
            setTypeSubmit(type)
            setValue("address_name", "")
            setValue("province_id", "")
            setValue("province_name", "")
            setValue("city_id", "")
            setValue("city_type", "")
            setValue("name", "")
            setValue("address", "")
            setValue("postal_code", "")
            setValue("address_id", "")
            document.getElementById('address_modal').showModal()
        } else {
            toast.error(`Maksimal daftar adalah ${process.env.REACT_APP_MAX_ADDRESS}`)
        }
    }
    // console.log('profile',profileImage)

    const handleChangeProvince = async (e) => {
        console.log(e)

        const params = {
            access: 'auth',
            method: API.CITY.type,
            url: API.CITY.url,
            reqBody: {
                province_id: e.value
            }
        }
        try {
            const response = await Api(params);
            if (response.status) {
                setCity(response.data.map((c) => {
                    return {
                        value: c.city_id,
                        label: `${c.type} ${c.city_name}`,
                        city_type: c.type
                    }
                }))
                setValue('province_id', e.value)
                setValue('province_name', e.label)
                setValue('city_id', null)
                setValue('city_name', null)
                setProvinceSelected(e)
                setCitySelected(null)
            } else {
                toast.error(response.message)
            }
        } catch (error) {
            toast.error(error.message)
        }
    }

    const handleChangeCity = (e) => {
        console.log(e)
        setCitySelected(e)
        setValue('city_id', e.value)
        setValue('city_name', e.label)
        setValue('city_type', e.city_type)
    }

    // console.log('city', city)

    const deleteAddress = (id) => {
        Swal.fire({
            title: "Yakin akan hapus alamat?",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Save",
            denyButtonText: `Don't save`,
            customClass: {
                title: 'text-base',
                confirmButton: 'bg-slate-700 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded',
                cancelButton: 'bg-grey-700 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded'
            }
        }).then( async (result) => {
            console.log(result)
            if(result.isConfirmed){
                const params = {
                    access: 'auth',
                    method: API.ADDRESS_DELETE.type,
                    url: API.ADDRESS_DELETE.url,
                    reqBody: {
                        address_id: id,
                        
                    }
                }

                try {
                    const response = await Api(params)
                    if(response.status){
                        toast(response.message)
                        initAddress()
                    }else{
                        toast.error(response.message)
                    }
                } catch (error) {
                    toast.error(error.message)
                }
            }
        })
    }

    const editAddress = async(data) => {
        // console.log(data)
        setDialogTitle('Sunting Alamat')
        setTypeSubmit('edit')
        setValue("address_id", data.address_id)
        setValue("address_name", data.address_name)
        setValue("province_id", data.province_id)
        setValue("province_name", data.province)
        
        setValue("city_type", data.city_type)
        setValue("address", data.full_address)
        setValue("postal_code", data.postal_code)
        setProvinceSelected({value:data.province_id,label:data.province_name})
        await handleChangeProvince({value:data.province_id,label:data.province_name})
        setCitySelected({value:data.city_id,label:`${data.city_type} ${data.city_name}`,city_type:data.city_type})
        setValue("city_id", data.city_id)
        setValue("city_name",data.city_name)
        document.getElementById('address_modal').showModal()
    }

    // Loading skeleton component
    const LoadingSkeleton = () => (
        <div className="animate-pulse space-y-6">
            <div className="bg-gray-200 h-32 rounded-xl"></div>
            <div className="bg-gray-200 h-20 rounded-lg"></div>
            <div className="space-y-3">
                <div className="bg-gray-200 h-4 rounded w-1/4"></div>
                <div className="bg-gray-200 h-32 rounded-lg"></div>
                <div className="bg-gray-200 h-32 rounded-lg"></div>
            </div>
        </div>
    )

    if (!profile) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
                <div className="mx-auto max-w-sm px-5 py-6">
                    <LoadingSkeleton />
                </div>
            </div>
        )
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
            <ToastContainer autoClose={1000} />
            <div className="mx-auto max-w-sm px-5 py-6">
                <div className='flex flex-col space-y-6 scrollbar-hide'>

                    {/* Profile Header Card */}
                    <Card className="bg-gradient-to-r from-white to-gray-50 shadow-xl border-0 overflow-hidden">
                        <div className="bg-gradient-to-r from-blue-500 to-purple-600 p-6 text-white">
                            <div className="flex items-center justify-center">
                                <div className="relative">
                                    <img
                                        src={profileImage || ProfilUnknow}
                                        onError={({ currentTarget }) => {
                                            currentTarget.onerror = null;
                                            currentTarget.src = ProfilUnknow;
                                        }}
                                        alt="profile"
                                        className='w-20 h-20 rounded-full border-4 border-white shadow-lg object-cover'
                                    />
                                    <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-green-500 rounded-full border-2 border-white"></div>
                                </div>
                            </div>
                            <div className="text-center mt-4">
                                <h2 className="text-xl font-bold">
                                    {profile?.firstname ? profile.firstname : 'Belum ada nama'} {profile?.lastname ? profile.lastname : ''}
                                </h2>
                                <div className="flex items-center justify-center mt-2 space-x-4 text-sm opacity-90">
                                    <div className="flex items-center space-x-1">
                                        <AiOutlinePhone className="text-sm" />
                                        <span>{profile?.phone || 'No phone'}</span>
                                    </div>
                                </div>
                                <div className="flex items-center justify-center mt-1 space-x-1 text-sm">
                                    <AiOutlineMail className="text-sm" />
                                    <span>{profile?.email || 'belum mengisi email'}</span>
                                </div>
                            </div>
                        </div>
                        <Card.Body className="p-4">
                            <div className="flex justify-between items-center">
                                <div className="flex items-center space-x-2">
                                    <AiOutlineUser className="text-gray-500" />
                                    <span className="text-sm text-gray-600">Member sejak 2024</span>
                                </div>
                                <Button
                                    size="sm"
                                    className="bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white border-none"
                                >
                                    Update Profile
                                </Button>
                            </div>
                        </Card.Body>
                    </Card>

                    {/* Address Section */}
                    <div className="space-y-4">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center space-x-2">
                                <AiOutlineEnvironment className="text-gray-600" />
                                <h3 className="text-lg font-semibold text-gray-800">Daftar Alamat</h3>
                            </div>
                            <Button
                                size="sm"
                                className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white border-none"
                                onClick={() => { handleAddAddress('Tambah Alamat', 'create') }}
                            >
                                <AiOutlinePlus className="mr-1" />
                                Tambah
                            </Button>
                        </div>

                        {address.length === 0 ? (
                            <Card className="bg-gradient-to-r from-gray-50 to-white border-2 border-dashed border-gray-300">
                                <Card.Body className="text-center py-8">
                                    <FaMapMarkerAlt className="text-4xl text-gray-400 mx-auto mb-3" />
                                    <p className="text-gray-500 font-medium">Belum ada alamat tersimpan</p>
                                    <p className="text-sm text-gray-400 mt-1">Tambahkan alamat untuk memudahkan pengiriman</p>
                                </Card.Body>
                            </Card>
                        ) : (
                            <div className="space-y-3">
                                {address.map((a, i) => (
                                    <Card key={i} className="bg-white shadow-lg hover:shadow-xl transition-all duration-300 border-0">
                                        <Card.Body className="p-4">
                                            <div className="flex items-start justify-between">
                                                <div className="flex-1">
                                                    <div className="flex items-center space-x-2 mb-2">
                                                        <FaMapMarkerAlt className="text-red-500" />
                                                        <h4 className="font-semibold text-gray-800">{a.address_name}</h4>
                                                    </div>
                                                    <p className="text-gray-600 text-sm mb-1">{a.full_address}</p>
                                                    <p className="text-gray-500 text-sm">{a.city_name}, {a.province_name} - {a.postal_code}</p>
                                                </div>
                                                <div className="flex space-x-1">
                                                    <Button
                                                        size="sm"
                                                        className="bg-blue-500 hover:bg-blue-600 text-white border-none p-2"
                                                        onClick={() => editAddress(a)}
                                                    >
                                                        <AiOutlineEdit className="text-sm" />
                                                    </Button>
                                                    <Button
                                                        size="sm"
                                                        className="bg-red-500 hover:bg-red-600 text-white border-none p-2"
                                                        onClick={() => deleteAddress(a.address_id)}
                                                    >
                                                        <AiOutlineDelete className="text-sm" />
                                                    </Button>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* Logout Button */}
                    <div className="flex justify-center pt-4">
                        <Button
                            onClick={handleLogout}
                            className="bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white border-none px-8 py-3 rounded-lg shadow-lg"
                        >
                            <AiOutlineLogout className="mr-2" />
                            Logout
                        </Button>
                    </div>
                </div>
            </div>

            {/* Modern Modal */}
            <Modal id="address_modal" className="modal">
                <Modal.Header className="bg-gradient-to-r from-blue-500 to-purple-600 text-white">
                    <h3 className="font-bold text-lg">{dialogTitle}</h3>
                </Modal.Header>
                <Modal.Body>
                    <form id="address-form" onSubmit={handleSubmit(onSubmit)} className="space-y-4">
                        <div>
                            <label className="label">
                                <span className="label-text font-semibold">Nama Penerima</span>
                            </label>
                            <input
                                className="input input-bordered w-full focus:input-primary"
                                placeholder='Nama lengkap penerima'
                                {...register("address_name", { required: true })}
                            />
                            {errors.address_name && <span className="text-red-500 text-sm">Nama wajib diisi</span>}
                        </div>

                        <div>
                            <label className="label">
                                <span className="label-text font-semibold">Provinsi</span>
                            </label>
                            <Select
                                {...register("province_id", { required: true })}
                                value={provinceSelected}
                                onChange={handleChangeProvince}
                                options={province}
                                placeholder="Pilih Provinsi..."
                                className="react-select-container"
                                classNamePrefix="react-select"
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        border: '1px solid #e5e7eb',
                                        borderRadius: '0.5rem',
                                        padding: '0.25rem',
                                        '&:hover': { borderColor: '#3b82f6' },
                                        '&:focus': { borderColor: '#3b82f6', boxShadow: '0 0 0 1px #3b82f6' }
                                    })
                                }}
                            />
                            <input type="hidden" {...register("province_name", { required: true })} />
                        </div>

                        <div>
                            <label className="label">
                                <span className="label-text font-semibold">Kota/Kabupaten</span>
                            </label>
                            <Select
                                {...register("city_id", { required: true })}
                                value={citySelected}
                                onChange={handleChangeCity}
                                options={city}
                                placeholder="Pilih Kota/Kabupaten..."
                                isDisabled={!provinceSelected}
                                className="react-select-container"
                                classNamePrefix="react-select"
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        border: '1px solid #e5e7eb',
                                        borderRadius: '0.5rem',
                                        padding: '0.25rem',
                                        '&:hover': { borderColor: '#3b82f6' },
                                        '&:focus': { borderColor: '#3b82f6', boxShadow: '0 0 0 1px #3b82f6' }
                                    })
                                }}
                            />
                            <input type="hidden" {...register("city_name", { required: true })} />
                        </div>

                        <div>
                            <label className="label">
                                <span className="label-text font-semibold">Alamat Lengkap</span>
                            </label>
                            <textarea
                                className="textarea textarea-bordered w-full h-24 focus:textarea-primary"
                                placeholder="Jl. Contoh No. 123, RT/RW 01/02, Kelurahan, Kecamatan..."
                                {...register("address", { required: true })}
                            ></textarea>
                            {errors.address && <span className="text-red-500 text-sm">Alamat wajib diisi</span>}
                        </div>

                        <div>
                            <label className="label">
                                <span className="label-text font-semibold">Kode Pos</span>
                            </label>
                            <input
                                className="input input-bordered w-full focus:input-primary"
                                placeholder='12345'
                                {...register("postal_code", { required: true })}
                            />
                            {errors.postal_code && <span className="text-red-500 text-sm">Kode pos wajib diisi</span>}
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Actions className="justify-end space-x-2">
                    <Button
                        type="button"
                        variant="outline"
                        onClick={()=>{document.getElementById('address_modal').close()}}
                    >
                        Batal
                    </Button>
                    <Button
                        type="submit"
                        form="address-form"
                        className="bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white border-none"
                        disabled={!proccessing}
                    >
                        {proccessing ? 'Simpan' : 'Menyimpan...'}
                    </Button>
                </Modal.Actions>
            </Modal>
        </div>
    )
}

export default Profile